import React, { useEffect, useState } from "react";
import ReactModalWrap from "../common/ReactModalWrap";
import styles from "./Modal.module.scss";
import Button from "../common/Button";
import NumberStepperControl from "../common/NumberStepperControl";

function CreditValueEditorModal({
  open,
  close,
  initialLimitValue = null,
  onSubmit,
  header,
  subHeader,
  btnLabel,
  minValue = 0
}) {
  const [value, setValue] = useState(initialLimitValue);

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (initialLimitValue != null) {
      setValue(Number.parseFloat(String(initialLimitValue)) || 0);
    }
  }, [initialLimitValue]);

  return (
    <ReactModalWrap isOpen={open} close={close}>
      <div className={styles.content}>
        <div className={styles.header}>{header}</div>
        <NumberStepperControl
          className={styles.creditValueEditorModalNumberHandler}
          label={subHeader}
          value={Number(value) || 0}
          min={minValue}
          step={500}
          onChange={setValue}
        />

        <Button
          onClick={ async () => {
            setLoading(true);
            await onSubmit(value);
            setLoading(false)
          }}
          disabled={value == null || value < minValue || loading}
          className={styles.setNewLimit}
          variant="green"
        >
          {btnLabel}
        </Button>
      </div>
    </ReactModalWrap>
  );
}

export default CreditValueEditorModal;
